import { Component, EventEmitter, Input, Output, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';

import {
  ContributeWizardService,
  PaymentMethod,
} from '../../services/contribute-wizard.service';

@Component({
  selector: 'app-step-review-confirm',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ButtonModule],
  templateUrl: './step-review-confirm.component.html',
})
export class StepReviewConfirmComponent {
  @Input() submitting = false;
  @Output() back = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<void>();

  protected wizardService = inject(ContributeWizardService);
  private transloco = inject(TranslocoService);

  // Computed for button label based on payment method
  submitButtonLabel = computed(() => {
    const method = this.wizardService.selectedPaymentMethod();
    if (method === 'CARD') return 'contribute.payment.proceedToPayment';
    if (method === 'BANK_TRANSFER') return 'contribute.payment.getBankDetails';
    return 'contribute.payment.selectPaymentMethod';
  });

  // Check if payment method is selected
  canSubmit = computed(() => this.wizardService.selectedPaymentMethod() !== null);

  getProjectName(): string {
    const project = this.wizardService.selectedProject();
    if (!project) return '';

    const lang = this.transloco.getActiveLang().toUpperCase();
    if (lang === 'FR') return project.nameFR || project.nameEN;
    if (lang === 'NL') return project.nameNL || project.nameEN;
    return project.nameEN;
  }

  selectPaymentMethod(method: PaymentMethod): void {
    this.wizardService.setPaymentMethod(method);
  }

  onBack(): void {
    this.back.emit();
  }

  onSubmit(): void {
    if (this.canSubmit()) {
      this.submitForm.emit();
    }
  }
}
